(() => {
  const GLOBAL_KEY = 'B2BLookbookLanding';
  const SELECTOR = '.js-b2b-lookbook-open-form';

  if (window[GLOBAL_KEY] && typeof window[GLOBAL_KEY].bindButtons === 'function') {
    window[GLOBAL_KEY].bindButtons(document);
    return;
  }

  function openKlaviyoForm(formId) {
    if (!formId) {
      return false;
    }

    window._klOnsite = window._klOnsite || [];
    window._klOnsite.push(['openForm', formId]);

    return true;
  }

  function openFallback(button) {
    const fallbackUrl = button.dataset.fallbackUrl;
    const fallbackEmail = button.dataset.fallbackEmail;

    if (fallbackUrl) {
      window.location.assign(fallbackUrl);
      return;
    }

    if (fallbackEmail) {
      window.location.href = `mailto:${fallbackEmail}`;
      return;
    }

    if (window.console && typeof window.console.warn === 'function') {
      window.console.warn('[B2B Lookbook] Missing Klaviyo form ID and fallback target.');
    }
  }

  function bindButtons(root = document) {
    const buttons = root.querySelectorAll(SELECTOR);

    buttons.forEach((button) => {
      if (button.dataset.b2bBound === 'true') {
        return;
      }

      button.dataset.b2bBound = 'true';

      button.addEventListener('click', () => {
        const formId = button.dataset.klaviyoFormId;

        if (!openKlaviyoForm(formId)) {
          openFallback(button);
        }
      });
    });
  }

  window[GLOBAL_KEY] = {
    bindButtons,
    openKlaviyoForm
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => bindButtons(document));
  } else {
    bindButtons(document);
  }

  document.addEventListener('shopify:section:load', (event) => {
    bindButtons(event.target);
  });
})();
